import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./appDateRange.scss";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { DateRange } from "react-date-range";

import { format, parse, startOfMonth } from "date-fns";

import { resetDateRange, setInputDate } from "../store/features/globalSlice";
import { getInputDate } from "../utils/utils";

import DateIcon from "../static/icons/calendar.png";
import { OnlyInPc } from "./Responsive";
import { Button } from "./ui/buttons/Button";
import Drawer from "./ui/Drawer";
import { DATE_FORMAT } from "../consts/AppContants";
import { AppColors } from "../consts/colors";
import { Calendar } from "react-feather";

const AppDateRange = () => {
  const dispatch = useDispatch();
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: startOfMonth(new Date()),
      key: "dateRange",
    },
  ]);

  const inputDate = useSelector((state) => state.global.inputDate);

  const toggleDateRangePicker = () => setIsPickerOpen(!isPickerOpen);

  return (
    <>
      <a className="btn btn-light" onClick={toggleDateRangePicker}>
        <div className="d-flex align-items-center">
          <Calendar size={14} color={AppColors.grey3} className="me-1" />

          <OnlyInPc>
            {inputDate.startDate ? (
              <span className="ms-2">{`${inputDate.startDate} - ${inputDate.endDate}`}</span>
            ) : (
              <span className="ms-2">Select Date</span>
            )}
          </OnlyInPc>
        </div>
      </a>
      {isPickerOpen && (
        <DateRangeDrawer
          dateRange={dateRange}
          setDateRange={setDateRange}
          toggleDateRangePicker={toggleDateRangePicker}
        />
      )}
    </>
  );
};

const DateRangeDrawer = ({
  toggleDateRangePicker,
  dateRange,
  setDateRange,
}) => {
  const dispatch = useDispatch();
  const inputDate = useSelector((state) => state.global.inputDate);

  // Setting Default Date
  useEffect(() => {
    setDateRange([
      {
        startDate: parse(inputDate.startDate, DATE_FORMAT, new Date()),
        endDate: parse(inputDate.endDate, DATE_FORMAT, new Date()),
        key: "dateRange",
      },
    ]);
  }, []);

  const handleDateRange = () => {
    dispatch(
      setInputDate({
        startDate: format(dateRange[0].startDate, "dd/MM/yyyy"),
        endDate: format(dateRange[0].endDate, "dd/MM/yyyy"),
        date: getInputDate({
          startDate: format(dateRange[0].startDate, "dd/MM/yyyy"),
          endDate: format(dateRange[0].endDate, "dd/MM/yyyy"),
        }),
      })
    );
    // Close the date range picker on selecting the date
    toggleDateRangePicker();
  };

  return (
    <>
      <Drawer
        title={"Select Date Range"}
        width={375}
        onClose={toggleDateRangePicker}
      >
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <DateRange
              onChange={(item) => {
                setDateRange([item.dateRange]);
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              ranges={dateRange}
              rangeColors={["#22B470"]}
            />

            <Button
              className="btn btn-primary mb-3"
              onClick={handleDateRange}
              text="Set Date"
            />
          </div>
          <div className="col-sm-12 col-md-12 col-sm-12 offset-lg-3"></div>
        </div>
      </Drawer>
    </>
  );
};

export default AppDateRange;
